import { createEntitySlice } from '@/shared/store/createEntitySlice';
import { bannersApi } from '../api';
import type { Banner, BannerFilters, BannerFormData } from '../types';

const initialState = {
  items: [] as Banner[],
  loading: false,
  error: null as string | null,
  currentPage: 1,
  perPage: 20,
  total: 0,
  lastPage: 1,
  filters: {
    search: '',
    dateRange: null,
    status: '',
    location: '',
  } as BannerFilters,
};

const { actions, reducer } = createEntitySlice<Banner, BannerFilters, BannerFormData>({
  name: 'banners',
  api: bannersApi,
  initialState,
  getListParams: (state) => {
    const { currentPage, perPage, filters } = state.banners;
    const params: {
      page: number;
      perPage: number;
      search?: string;
      status?: string;
      location?: string;
      startDate?: string;
      endDate?: string;
    } = {
      page: currentPage,
      perPage,
    };

    if (filters.search) {
      params.search = filters.search;
    }

    if (filters.status) {
      params.status = filters.status;
    }

    if (filters.location) {
      params.location = filters.location;
    }

    if (filters.dateRange?.start) {
      params.startDate = filters.dateRange.start;
    }

    if (filters.dateRange?.end) {
      params.endDate = filters.dateRange.end;
    }

    return params;
  },
});

export const {
  fetchItems: fetchBanners,
  createItem: createBanner,
  updateItem: updateBanner,
  deleteItem: deleteBanner,
  setPage,
  setPerPage,
  setFilters,
} = actions;

export { reducer };
